<template>
  <v-select
    :items="items"
    :label="label"
    @change="onInput"
    v-model="model"
    color="teal lighten-2"
    clearable
    hide-details
  ></v-select>
</template>
<script>
export default {
  name: 'status-select',
  data () {
    return {
      model: this.value
    }
  },
  methods: {
    onInput () {
      const index = this.items.filter(obj => { return obj.value === this.model })[0]
      this.$emit('input', index?.value.toString())
    }
  },
  props: {
    value: {
      type: String
    },
    items: {
      type: Array
    },
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
